<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-2 d-print-none d-flex align-items-center">
          <span class="toolbar-title">{{ moduleTitle }}</span>
        </div>
        <div
          class="col-sm-12 col-md-4 d-flex align-items-start flex-column justify-content-center"
        >
          <h1
            *ngIf="wfTableConfig?.id"
            [ngClass]="{
              blue: wfTableConfig?.status == 1,
              gray: wfTableConfig?.status == 0,
              yellow: wfTableConfig?.status == -1
            }"
          >
            <span class="bold">{{ wfTableConfig?.formName }}</span> Workflow
            Details ({{ wfTableConfig?.name }})
          </h1>
        </div>
        <div
          class="col-12 col-md-3 small d-flex flex-column justify-content-center align-items-end"
        >
          <mat-slide-toggle [(ngModel)]="showLines" *ngIf="wfTableConfig?.id"
            >Show Leader Lines</mat-slide-toggle
          >
        </div>
        <div
          class="col-12 col-md-3 small d-flex flex-column justify-content-center align-items-end"
        >
          <div *ngIf="wfTableConfig?.id && !wfTableConfig?.approvedBy">
            Created by: <b>{{ wfTableConfig?.createdByName }}</b
            >&nbsp;on:
            <span class="date">{{ wfTableConfig?.createdOn | date }}</span>
          </div>

          <div *ngIf="wfTableConfig?.id">
            Updated by: <b>{{ wfTableConfig?.updatedByName }}</b
            >&nbsp;on:
            <span class="date">{{ wfTableConfig?.updatedOn | date }}</span>
          </div>
          <div *ngIf="wfTableConfig?.status == 1 && wfTableConfig?.approvedBy">
            Approved by:
            <b>{{ wfTableConfig?.approvedByName }}</b
            >&nbsp;on:
            <span class="date">{{ wfTableConfig?.approvedOn | date }}</span>
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <!-- <mat-list-item>
			<mat-icon
			  matListItemIcon
			  *ngIf="!isExpanded && !isShowing"
			  class="blue"
			  >search</mat-icon
			>
			<filter-box
			  (changed)="applyFilter($event)"
			  *ngIf="isExpanded || isShowing"
			></filter-box>
		  </mat-list-item> -->

        <!-- Table -->
        <mat-list-item style="height: unset">
          <div [ngClass]="{ invisible: !isExpanded && !isShowing }">
            <workflow-tree
              (nodeSelected)="displayInfo($event)"
              [creating]="creating"
              [editing]="editing"
            ></workflow-tree>
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons">
        <mat-list-item
          (click)="create()"
          class="parent"
          *ngIf="hasPrivilege(privilegeEnum.GlobalWorkflowEditor)"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="modify()"
          class="parent"
          *ngIf="
            hasPrivilege(privilegeEnum.GlobalWorkflowEditor) &&
            wfTableConfig?.status == -1 &&
            !creating &&
            !editing
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing">Modify</span>
          <mat-icon matListItemIcon class="yellow">edit</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="duplicate()"
          class="parent"
          *ngIf="
            hasPrivilege(privilegeEnum.GlobalWorkflowEditor) &&
            !creating &&
            !editing &&
            wfTableConfig?.id
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Duplicate</span
          >
          <mat-icon matListItemIcon class="blue">file_copy</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="delete()"
          class="parent"
          *ngIf="
            hasPrivilege(privilegeEnum.GlobalWorkflowEditor) &&
            wfTableConfig &&
            wfTableConfig.status <= 0 &&
            !creating &&
            !editing
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing">Delete</span>
          <mat-icon matListItemIcon class="red">delete</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div
          class="sidenav-content"
          [ngClass]="{
            amendment: false
          }"
        >
          <workflow-main
            *ngIf="wfTableConfig"
            [node]="node"
            [wfTableConfig]="wfTableConfig"
            [creating]="creating"
            [editing]="editing"
            [showLines]="showLines"
          ></workflow-main>
        </div>
        <div
          class="buttons d-print-none"
          id="sidenav-content-buttons"
          [ngClass]="{}"
        >
          <div class="row">
            <div class="col-6">
              <button
                mat-stroked-button
                *ngIf="(editing || creating) && hasPrivilege(privilegeEnum.GlobalWorkflowEditor)"
                color="warn"
                (click)="cancel()"
              >
                Cancel
              </button>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <button
                mat-flat-button
                *ngIf="(editing || creating) && hasPrivilege(privilegeEnum.GlobalWorkflowEditor)"
                color="accent"
                (click)="save()"
              >
                Save
              </button>

              <button
                mat-flat-button
                *ngIf="canApprove && wfTableConfig?.status == -1"
                color="primary"
                (click)="approve()"
              >
                Approve
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- "service.loading">
    <!-- Copyright 2017 Google Inc. All Rights Reserved.
		Use of this source code is governed by an MIT-style license that
		can be found in the LICENSE file at http://angular.io/license -->
  <!-- </overlay-loading> -->
</div>
